export default __webpack_public_path__ + "static/media/c-providore.e2d43fda.png";